import React from 'react';

const BrandBanner__1 = () => {
    return (
        <div className="brand-banner--1-wrapper xmy-12 xmy-lg-20 xpy-5 xpx-10 xpy-lg-0 xpx-lg-0 text-center">
            <h3 className="banner-title">
                پس از موفقیت سری ردمی نوت ۸، اکنون کار شیائومی برای بهبود این سری سخت شد.
            </h3>
        </div>
    );
};

export default BrandBanner__1;
